export function format(dateString) {
  if (dateString === undefined) return undefined;
  return new Date(dateString).toLocaleString('pt-BR');
}

export function formatDate(dateString) {
  if (dateString === undefined) return undefined;
  return new Date(dateString).toLocaleString('pt-BR').substring(0, 10);
}

export function formatTime(dateString) {
  if (dateString === undefined) return undefined;
  return new Date(dateString).toLocaleString('pt-BR').split(' ')[1].substring(0, 5);
}

export function getYear(dateString) {
  if (dateString === undefined) return undefined;
  return new Date(dateString).toLocaleString('pt-BR').substring(0, 4);
}
